import { AdvancedToolbar } from "./AdvancedToolbar";
import { DecoratorProps } from "./DecoratorProps";
import { Decorator } from "./Decorator";
import { LayoutHeader } from "../../components/layoutheader/LayoutHeader";

export class AdvancedDecorator extends Decorator {
    toolbar: AdvancedToolbar;

    constructor(props: Partial<DecoratorProps>) {
        super({ fillRow: true, fillHeight: true, ...props });
    }

    override setupPanels(props: Partial<DecoratorProps>) {
        this.toolbar = new AdvancedToolbar({ fillRow: true, dataSource: props.layout.mainDataSource });
        const header = this.layout.findComponentByType(LayoutHeader);
        if (header) {
            this.toolbar.setProps({ padding: 0, paddingTop: 8, paddingLeft: 8, margin: 0 });
            header.addlPanelLeft.insert(this.toolbar, 0);
        } else {
            this.add(this.toolbar);
        }
    }
}
